export const SLIDER_SEARCH = 'SLIDER_SEARCH';
export const SLIDER_VIEW = 'SLIDER_VIEW';
export const SLIDER_VIEW_LOADED = 'SLIDER_VIEW_LOADED';
export const SLIDER_CREATE = 'SLIDER_CRAETE';
export const SLIDER_UPDATE = 'SLIDER_UPDATE';
export const SLIDER_CREATE_SUCCESS = 'SLIDER_CREATE_SUCCESS';
export const SLIDER_UNLOAD = 'SLIDER_UNLOAD';
export const SLIDER_DELETE = 'SLIDER_DELETE';
export const SLIDER_DELETE_SUCCESS = 'SLIDER_DELETE_SUCCESS';
